(()=>{
 'use strict';
 const mounted=new Map(),reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const mount=root=>{
  if(mounted.has(root)||!('IntersectionObserver' in window))return;
  const events=new AbortController(),running=new Set();
  const about=root.matches('[data-ura-about-story]');
  const targets=[...root.querySelectorAll(about?'.uas18-section-head,.uas18-equation>div,.uas19-belief-grid>article,.uas18-collections>a,.uas18-founder>div,.uas18-founder>figure':'.uvh-design-board,.uvh-work__heading,.uvh-type-display>span,.uvh-system-mark,.uvh-service,.uvh-approach li,.uvh-contact__inner')];
  const finish=()=>{running.forEach(a=>a.cancel());running.clear();};
  const observer=new IntersectionObserver(entries=>{
   entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    const node=entry.target;observer.unobserve(node);node.dataset.uraMotionSeen='true';
    if(reduced.matches||typeof node.animate!=='function')return;
    const siblings=[...node.parentElement.children].filter(n=>targets.includes(n));
    const delay=Math.min(3,Math.max(0,siblings.indexOf(node)))*65;
    const isArtwork=node.matches('.uvh-system-mark');
    const motion=node.animate(isArtwork?[{opacity:.4},{opacity:1}]:[{opacity:.2,transform:'translate3d(0,12px,0)'},{opacity:1,transform:'translate3d(0,0,0)'}],{duration:600,delay,easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'});
    running.add(motion);motion.finished.then(()=>{running.delete(motion);motion.cancel();}).catch(()=>running.delete(motion));
   });
  },{threshold:0,rootMargin:'0px 0px -32px 0px'});
  targets.forEach(node=>observer.observe(node));
  reduced.addEventListener('change',()=>{if(reduced.matches)finish();},{signal:events.signal});
  root.addEventListener('focusin',finish,{signal:events.signal});
  const dispose=()=>{events.abort();observer.disconnect();finish();mounted.delete(root);};
  mounted.set(root,dispose);
 };
 let footerObserver;
 const scan=()=>{
  document.querySelectorAll('[data-ura-about-story],[data-ura-design-story]').forEach(mount);
  footerObserver?.disconnect();
  const footer=document.querySelector('[data-ura-signature-footer],.uvh-footer');
  if(footer&&'IntersectionObserver' in window){
   footerObserver=new IntersectionObserver(entries=>{
    document.body.toggleAttribute('data-ura-footer-inview',entries[0].isIntersecting);
   },{threshold:0});
   footerObserver.observe(footer);
  }
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
 document.addEventListener('shopify:section:load',scan);
 document.addEventListener('shopify:section:unload',event=>mounted.forEach((dispose,root)=>{if(event.target.contains(root))dispose();}));
})();
